const styles = ({ screenSizes, spacing, typography }) => ({
  ...typography.p,
  ...typography.p3,
  marginBottom: 0,
  padding: [0, 0, spacing.sm, 0],
  textAlign: 'center',
  width: '100%',
  [`@media(max-width: ${screenSizes.mobileMax}px)`]: {
    padding: [0, 0, '0.5em', 0],
  },
});

export default styles;
